//Actions
import {
  SET_ADMIN_BATCHES_DATA,
  SET_ADMIN_BATCHES_FILTERS_LABELS,
  SET_ADMIN_BATCHES_FILTERS,
  SET_ADMIN_BATCHES_LOADER,
  CLEAR_ADMIN_BATCHES_FILTERS,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  batches: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalBatchesInDB: null,
  filterslabels: [],
  loading: false,
  applyFilters: false,
  filterSize: null,
  totalRevenue: 0,
  totalQuantity: 0,
  filters: {},
};

const adminBatchesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ADMIN_BATCHES_DATA:
      return {
        ...state,
        batches: payload.rows,
        rowsCount: payload.count,
        totalBatchesInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        totalRevenue: payload.totalRevenue,
        totalQuantity: payload.totalQuantity,
      };
    case SET_ADMIN_BATCHES_LOADER:
      return { ...state, loading: payload };
    case SET_ADMIN_BATCHES_FILTERS_LABELS:
      return { ...state, filterslabels: payload };
    case SET_ADMIN_BATCHES_FILTERS:
      return {
        ...state,
        applyFilters: payload.applyFilters,
        filterSize: payload.filterSize,
        filters: payload.filters,
      };
    case CLEAR_ADMIN_BATCHES_FILTERS:
      return { ...state, applyFilters: false, filterSize: null, filters: {} };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { adminBatchesReducers };
